export default {
    title: "Orden en nombre de",
    model: {
        email: {
            label: "Correo electrónico",
            placeholder: "Por favor, rellene el nombre de usuario o correo electrónico",
            notFound: "Usuarios no encontrados",
            errors: {
                myself: "El correo electrónico debe ser diferente al suyo"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Entregar",
            processing: "Sumisión"
        }
    },
    error: {
        userNotExists: "{email} no existe",
        country: {
            default: "OI no está disponible actualmente en el país del usuario",
            ALPHA3: ""
        }
    }
}